<template>
  <div class="login">
    <van-popup
      v-model="showLogin"
      :close-on-click-overlay="false"
    ><login-form
      :state="state"
      title="绑定手机"
      tips="您需要绑定手机后使用"
      @success="onSuccess"
      @error="onError"
    /></van-popup>
  </div>
</template>

<script>
  
import LoginForm from '@/components/LoginForm'
import { mapState } from 'vuex'
export default {
  name: 'Login',
  components: {
    LoginForm
  },
  data() {
    return {
      showLogin: true,
      redirect: ''
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  mounted() {
    const user = this.$store.state.user
    console.log('mounted', user)
    if (user && user.member_type > 0) {
      this.onSuccess()
    }
  },
  computed: {
    ...mapState(['user']),
    state() {
      if ('state' in this.$route.query) {
        return this.$route.query.state
      }
      return ''
    }
  },
  methods: {
    onSuccess() {
      if (this.user) {
        if (this.user.member_type == 3) {
          this.$router.push({ path: '/DisChart' })
        } else if (this.user.member_type == 2) {
          this.$router.push({ path: '/GMChart' })
        }
      }
    },
    onError() {
      this.$router.replace('/error')
    }
  }
}
</script>
